module.exports = __webpack_public_path__ + "static/media/profile_background.cdbbf803.jpeg";